module.exports = __webpack_public_path__ + "static/media/explore-image-6.b49c736e.jpg";